// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { SettingsContext } from "../providers/SettingsContextProvider";
export function useGetPublicDocumentUrl() {
    var tenantId = useParams().tenantId;
    var globalSettings = useContext(SettingsContext).globalSettings;
    function getDocumentUrl(documentId, documentName) {
        return encodeURI("".concat(globalSettings.PUBLIC_BUCKET_URL, "tenant-").concat(tenantId, "/document-").concat(documentId, "/").concat(documentName));
    }
    return {
        getDocumentUrl: getDocumentUrl,
    };
}
